<template>
  <div>
		<div class="confirm-text">{{ msg }}</div>
		<div class="wy-btn-boder">
			<div class="wy-sure" @click="sure">{{ $t('message.qd') }}</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		msg: {
			type: String,
			default: ''
		}
	},
	beforeDestroy() {
		this.$store.commit('CHANGE_ALERT_TEXT', '');
	},
	methods: {
		sure () {
			this.$store.commit('CHANGE_ALERT_SHOW', false);
			this.$store.commit('CHANGE_PASS_SHOW', false);
		}
	}
}
</script>

<style scoped>
.confirm-text {
	padding-top: 12px;
}
.wy-btn-boder {
	padding-bottom: 10px;
	margin-top: 38px;
}
</style>